import {get, post} from '@/axios';

// 用户注册申请
 export const customerList = p => post('customer/customerList', p);
// 获取客户信息详情
 export const customerInfo = p => post('customer/customerInfo', p);
// 客户审批通过
 export const apply = p => post('customer/apply', p)
// 客户审批拒绝
 export const reject = p => post('customer/reject', p)

//删除未通过的
 export const deleteCustomer = p => post('customer/delete', p)
//修改基础信息
export const updateCustomer = p => post('customer/update', p)
//私有化部署一览
 export const page = p => post('rivatizationDeployment/page', p)
//意见反馈
 export const pageList = p => post('suggestion/pageList', p) 

 export async function initialization(request){
    let res = await post('customer/initialization', request)
    return res;
 }


// WEBPACK FOOTER //
// ./src/api/customer/customer.js